import { ISkuMeta, SkuCode, skuMetaList } from '@lib/config';
import { Box, Button, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import { defineMessage, MessageDescriptor, useIntl } from 'react-intl';

interface SkuListProps {
  onBuy: (skuCode: SkuCode) => void;
  activeSku: SkuCode | null;
  isLoading: boolean;
}

export const skuNameMessages: Record<SkuCode, MessageDescriptor> = {
  [SkuCode.m1]: defineMessage({
    defaultMessage: '1个月',
  }),
  [SkuCode.m12]: defineMessage({
    defaultMessage: '12个月',
  }),
  [SkuCode.forever]: defineMessage({
    defaultMessage: '买断',
  }),

  [SkuCode.m6]: defineMessage({
    defaultMessage: '6个月',
  }),

  [SkuCode.m3]: defineMessage({
    defaultMessage: '3个月',
  }),

  [SkuCode.w1]: defineMessage({
    defaultMessage: '1周',
  }),
};

export function SkuList(props: SkuListProps) {
  const intl = useIntl();
  const { onBuy, activeSku, isLoading } = props;

  return (
    <Stack gap={3}>
      <SimpleGrid gap={4} templateColumns="1fr 1fr 1fr">
        {skuMetaList.map((meta) => {
          return (
            <SkuItem
              {...meta}
              name={intl.formatMessage(skuNameMessages[meta.skuCode])}
              activeSkuCode={activeSku}
              isLoading={isLoading}
              onBuy={onBuy}
              key={meta.skuCode}
            />
          );
        })}
      </SimpleGrid>
      {/*<Text color="gray" fontSize="sm">*/}
      {/*  {intl.formatMessage(*/}
      {/*    {*/}
      {/*      defaultMessage:*/}
      {/*        '优惠活动：在 {year} 年 {month} 月之前购买永久版的用户，可将你的邀请返现比例从 15% 升级到 30%',*/}
      {/*    },*/}
      {/*    { year: 2025, month: 6 },*/}
      {/*  )}*/}
      {/*</Text>*/}
    </Stack>
  );
}

function SkuItem(
  props: {
    activeSkuCode: SkuCode | null;
    isLoading: boolean; // 单纯是否显示loading
    onBuy: (sku: SkuCode) => void;
  } & ISkuMeta,
) {
  const intl = useIntl();
  // 表示当前sku是否正在交易中
  const txProcessing = props.activeSkuCode === props.skuCode && props.isLoading;
  return (
    <Stack>
      <Box textAlign="center">{props.name}</Box>
      <Box textAlign="center">{props.ethPrice}ETH</Box>
      <Button
        onClick={() => props.onBuy?.(props.skuCode)}
        isLoading={txProcessing}
        loadingText={intl.formatMessage({
          defaultMessage: '处理中',
          id: 'purchase.processing',
        })}
        disabled={props.isLoading}
      >
        {intl.formatMessage({
          defaultMessage: '购买',
        })}
      </Button>
    </Stack>
  );
}
